import {getDictInfoByCode} from '@/api/dict'
export default {
  state: {
    productLineList: [],
    productTypeList: []
  },
  getters: {
    productLineList: state => state.productLineList,
    productTypeList: state => state.producTypeList,
  },
  mutations: {
    productLineList (state, data) {
      state.productLineList = data
    },
    productTypeList (state, data) {
      state.productTypeList = data
    }
  },
  actions: {
    handleProductLineList (productLineList){
      getDictInfoByCode({pCode:'PRODUCT_LINE'}).then(res => {
        if (res.status === 0) {
          productLineList.commit('productLineList', res.data)
        }
      })
    },
    handleProductTypeList (productTypeList){
      getDictInfoByCode({pCode:'PRODUCT_TYPE'}).then(res => {
        if (res.status === 0) {
          productTypeList.commit('productTypeList', res.data)
        }
      })
    }
  }
}
